import { useEffect, useState } from "react";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { BehaviorSubject } from "rxjs";

import { LocalizedText, resolveLocalizedText, translate, useTranslation } from "./shared/language";

interface InfoDialogProps {
  header?: LocalizedText;
  width?: string;
  body?: any;
}

const props = new BehaviorSubject<InfoDialogProps | null>(null);

export const InfoDialogService = {
  getProps: () => props.asObservable(),
  show: (infoDialogProps: InfoDialogProps) => {
    props.next(infoDialogProps);
  },
};

export const AppInfoDialog = () => {
  const [display, setDisplay] = useState(false);
  const [dialogProps, setDialogProps] = useState<InfoDialogProps>({});
  const { t } = useTranslation();

  useEffect(() => {
    const subscription = InfoDialogService.getProps().subscribe((nextProps) => {
      if (nextProps) {
        setDialogProps(nextProps);
        setDisplay(true);
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <Dialog
      header={typeof dialogProps.header === "string" ? translate(dialogProps.header) : resolveLocalizedText(dialogProps.header)}
      visible={display}
      style={{ width: dialogProps.width }}
      onHide={() => setDisplay(false)}
    >
      {dialogProps.body}
      <div className="flex justify-content-end">
        <Button
          label={t("common.close")}
          icon="pi pi-times"
          onClick={() => setDisplay(false)}
          className="p-button-sm"
        />
      </div>
    </Dialog>
  );
};
